/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from './spinner.component';
const styles_SpinnerComponent:any[] = ([] as any[]);
export const RenderType_SpinnerComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_SpinnerComponent,
  data: {}
}
);
export function View_SpinnerComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,':svg:svg',[
      [
        'class',
        'spinner'
      ]
      ,
      [
        'viewBox',
        '0 0 44 44'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[
      [
        'class',
        'spinner-circle'
      ]
      ,
      [
        'cx',
        '22'
      ]
      ,
      [
        'cy',
        '22'
      ]
      ,
      [
        'r',
        '20'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(null as any),(null as any));
}
function View_SpinnerComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-spinner',([] as any[]),(null as any),(null as any),(null as any),View_SpinnerComponent_0,RenderType_SpinnerComponent)),
    import0.ɵdid(49152,(null as any),0,import1.SpinnerComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const SpinnerComponentNgFactory:import0.ComponentFactory<import1.SpinnerComponent> = import0.ɵccf('woa-spinner',import1.SpinnerComponent,View_SpinnerComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvdWktZWxlbWVudHMvc3Bpbm5lci9zcGlubmVyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL3VpLWVsZW1lbnRzL3NwaW5uZXIvc3Bpbm5lci5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL3VpLWVsZW1lbnRzL3NwaW5uZXIvc3Bpbm5lci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvdWktZWxlbWVudHMvc3Bpbm5lci9zcGlubmVyLmNvbXBvbmVudC50cy5TcGlubmVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHN2ZyBjbGFzcz1cInNwaW5uZXJcIiB2aWV3Qm94PVwiMCAwIDQ0IDQ0XCI+XG4gICAgPGNpcmNsZSBjbGFzcz1cInNwaW5uZXItY2lyY2xlXCIgY3g9XCIyMlwiIGN5PVwiMjJcIiByPVwiMjBcIj48L2NpcmNsZT5cbjwvc3ZnPlxuIiwiPHdvYS1zcGlubmVyPjwvd29hLXNwaW5uZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQ0FBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQUF5QztJQUNyQztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7SUFBK0Q7SUFDN0Q7Ozs7OztJQ0ZOO2dCQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/app/ui-elements/spinner/spinner.component.ngfactory.ts